import "./modules/Accordion";
import "./modules/AOS";
import "./modules/BackToTop";
// import "./modules/CountUp";
// import "./modules/ExpandContent";
import "./modules/Fancybox";
// import "./modules/Gumshoe";
// import "./modules/ImageCompare";
import "./modules/Tablets";
// import "./modules/Tippy";
// import "./modules/VideoPlayer";

import { header } from "./header";
import scrollToElement from "./modules/ScrollElement";
import swiperInit from "./modules/Swiper";
import lozadInit from "./modules/Lozad";
import { CTAInit } from "./modules/Helper";
import menuspyInit from "./modules/Menuspy";

$(function () {
	header.init();
	swiperInit();
	lozadInit();
	CTAInit();
	menuspyInit();

	$(".anchor-link").on("click", function (e) {
		e.preventDefault();
		let href = $(this).attr("href");
		scrollToElement(href, 1000, $("header").height());
	});
});
